export const CUSTOMER_INFO_TEST_ID = {
  submitButton: 'continue-to-payment',
  specialInstructionTextField: 'special-instructions-test',
  firstName: 'first-name',
  lastName: 'last-name',
  phoneNumber: 'phone-number',
  emailAddress: 'email-address',
  marketingAllowed: 'marketing-allowed',
  readOnly: 'customer-info-read-only',
  edit: 'customer-info-edit',
  deliveryEdit: 'customer-info-delivery-edit',
  deliveryAddressEdit: 'customer-info-delivery-address-edit',
  delivery: 'customer-info-delivery',
  helpText: 'customer-info-help-text',
  stayLoggedIn: 'stay-logged-in'
};

export const NOTE_TEST_ID = 'note';

export const SERVICE_TYPE_NOTE = 'service_type_note';
